import React from 'react';
import { Navigate } from 'react-router';
import { Survey } from '../../entities/Survey';
import { SurveyStatus } from '../../entities/SurveyStatus';

interface PropTypes {
  survey: Survey;
  status: SurveyStatus;
  mismatchPath: string;
  children: JSX.Element;
}

export function SurveyRoute(props: PropTypes) {
  if (props.status !== props.survey.status) {
    return <Navigate to={props.mismatchPath} />;
  }

  return props.children;
}
